<!-- Orientação Portabilidade -->

<div id="orientacao-portabilidade-sumula">
  <section *ngIf="mostrarOrientacaoPortabilidade">
    <div *ngIf="mostrarHeader" class="header" style="margin-bottom: 0px">
      <div class="logo-operadora d-flex justify-content-center col-12">
        <img src="../../../../../../assets/app-assets/images/documentos-header/aditivo-reducao-de-carencia.png" />
      </div>
    </div>
    <div *ngIf="mostrarHeader" class="row mb-5">
      <div class="col-md-12 d-flex alinhamento-header-mobile">
        <div class="col-md-4">
          <p class="text-center"><b>Entidade</b></p>
          <p style="font-size: 14px">{{ entidadeProposta }} - {{ razaoSocialEntidade }}</p>
        </div>
        <div class="col-md-4">
          <p class="text-center"><b>Nº da Proposta</b></p>
          <p class="text-center">{{ codigoProposta }}</p>
        </div>
        <div class="col-md-4">
          <ng-container *ngIf="vigenciaProposta">
            <p class="text-center"><b>Vigência</b></p>
            <p class="text-center">{{ vigenciaProposta }}</p>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="documentos-container mt-4">
      <h3 class="titulo text-center bold-preto-700 mb-1 p-1 m-1" style="background: #ccc; border-radius: 10px">
        Termo de Orientação da Portabildade
      </h3>
      <div class="card-body">
        <p class="mb-1 alinhamento-texto-mobile">
          Prezado Sr. (a)Seja bem-vindo ao processo de compra online, Para realizar a análise do processo de
          portabilidade para operadora Unimed Fesp, lembrando que para este processo temos um prazo de 48 horas desde o
          início da compra, sua finalização e toda a análise da corretora, caso esse prazo seja excedido o processo é
          declinado, sendo necessário iniciá-lo novamente.
        </p>
        <p class="mb-1">
          <b>Critérios da RN 438/18 para realização do processo de portabilidade de carência:</b>
        </p>

        <p class="mb-1 alinhamento-texto-mobile">
          1. Para exercer a portabilidade se faz necessário estar ativo e adimplente no plano de origem a no mínimo 2
          anos **[1];
        </p>
        <p class="mb-1 alinhamento-texto-mobile">
          2. O plano atual deve ter sido contratado após 1º de janeiro de 1999 ou ter sido adaptado à Lei dos Planos de
          Saúde (Lei nº 9.656/98);
        </p>
        <p class="mb-1 alinhamento-texto-mobile">
          3. O plano destino precisa ser igual ou inferior ao plano de origem (com isso, se faz necessária a verificação
          de compatibilidade entre os planos, no site da ANS);
        </p>
        <p class="mb-1 alinhamento-texto-mobile"><b>Considerações importantes:</b></p>
        <ul>
          <li>
            <p class="alinhamento-texto-mobile">
              • A operadora de destino (UNIMED FESP) tem 10 dias corridos a contar da data de assinatura da proposta,
              para enviar comunicado sobre aceitação ou recusa da solicitação de Portabilidade.
            </p>
          </li>
          <li>
            <p class="alinhamento-texto-mobile">
              • O plano de origem (atual) deverá ser cancelado em até 5 dias corridos, a contar da data de vigência do
              plano de destino (UNIME FESP), responsabilidade do cliente realizar o cancelamento do plano.
            </p>
          </li>
          <li>
            <p class="alinhamento-texto-mobile">
              • Lembrando que a carta de portabilidade tem validade de 30 dias (incluindo os 10 dias que a operadora tem
              para análise).
            </p>
          </li>
          <li>
            <p class="alinhamento-texto-mobile">
              • A 1ª mensalidade será cobrada no 5º dia útil do mês da vigência do plano via débito automático.
            </p>
          </li>
        </ul>
        <p class="mb-1 mt-2 alinhamento-texto-mobile">
          ** [1]Em caso se portabilidade já realizada anteriormente, esse prazo diminui para 1 ano e, em caso de CPT
          (Cobertura Parcial Temporária) aumenta para três. Observando também que, em caso de perda de vínculo no plano
          empresarial – sem demissão por justa causa – esse prazo mínimo não é necessário. Para mais informações, segue
          link: http://www.ans.gov.br/index.php/planos-de-saude-e-
          operadoras/contratacao-e-troca-de-plano/trocar-de-plano-de-saude-sem-cumprir-carencia/707-portabilidade-de-carencias.
          01
        </p>
      </div>
    </div>
  </section>
  <!-- Orientação Súmula -->
  <section *ngIf="mostrarOrientacaoSumula">
    <div *ngIf="mostrarHeader" class="header" style="margin-bottom: 0px">
      <div class="logo-operadora d-flex justify-content-center col-12">
        <img src="../../../../../../assets/app-assets/images/documentos-header/aditivo-reducao-de-carencia.png" />
      </div>
    </div>
    <div *ngIf="mostrarHeader" class="row mb-5">
      <div class="col-md-12 d-flex">
        <div class="col-md-4">
          <p class="text-center"><b>Entidade</b></p>
          <p style="font-size: 14px">{{ entidadeProposta }} - {{ razaoSocialEntidade }}</p>
        </div>
        <div class="col-md-4">
          <p class="text-center"><b>Nº da Proposta</b></p>
          <p class="text-center">{{ codigoProposta }}</p>
        </div>
        <div class="col-md-4">
          <ng-container *ngIf="vigenciaProposta">
            <p class="text-center"><b>Vigência</b></p>
            <p class="text-center">{{ vigenciaProposta }}</p>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="documentos-container mt-4">
      <h3 class="titulo text-center bold-preto-700 mb-1 p-1 m-1" style="background: #ccc; border-radius: 10px">
        Termo de Orientação da Súmula 21
      </h3>

      <div class="card-content">
        <div class="card-body">
          <p class="mb-1 alinhamento-texto-mobile">
            <strong>Súmula 21</strong>
            garante ao beneficiário a mudança de administradora permanecendo na mesma operadora (de UNIMED FESP para
            UNIMED FESP), se faz necessário estar ativo e adimplente até o dia que antecede a vigência do plano destino,
            a súmula 21 dá continuidade ao contrato atual, onde todas as carências já cumpridas vão para o plano destino
            cumpridas, e as carências faltantes cumprir serão cumpridas no nosso contrato.
          </p>

          <p class="mb-1 alinhamento-texto-mobile">
            No ato da adesão será cobrada a taxa de adesão de acordo com o plano escolhido, pode ser pago via
            depósito/transferência bancária ou PagSeguro (cartão de crédito).
            <br class="mt-1" />
            A 1ª mensalidade será cobrada via débito automático no
            <strong>5º dia útil após a data de vigência do plano.</strong>
            Como o plano é coletivo por adesão e se faz necessário ter elegibilidade com algum sindicato
            classista/setorial de acordo com sua profissão ou formação.
          </p>

          <p class="mb-1 alinhamento-texto-mobile bold">
            Para seguir com adesão via súmula 21, solicitamos por gentileza, o envio da documentação a seguir:
          </p>

          <p class="mb-1 alinhamento-texto-mobile">
            <strong>Titular</strong>
            : RG-CPF, Comprovante de residência (água, gás, luz ou telefone, emitido em até 3 meses), cartão do SUS,
            holerite atualizado, carteirinha do plano atual, carta de permanência atualizada, 3 últimos boletos pagos,
            comprovante bancário Caixa, Santander, Banco do Brasil e Itaú (cabeçalho do extrato, cartão ou cheque).
          </p>
          <p class="alinhamento-texto-mobile bold">
            A carta de permanência tem validade de até 30 dias se fazendo necessário todo o processo de adesão ser feito
            dentro deste período.
          </p>
        </div>
      </div>
    </div>
  </section>
</div>
